// import logo from './logo.svg';
import './App.css';
import './lib/animate/animate.min.css';
import './lib/lightbox/css/lightbox.min.css';
import './lib/owlcarousel/assets/owl.carousel.min.css';
import './css/bootstrap.min.css';
import './css/style.css';
import './css/stock.css';


// src/App.js
import React, {useEffect, useState} from 'react';
import { StockProvider } from "./components/stocks/stock_context";
import {useParams} from "react-router-dom";
import {fetchPage} from "./api";
import NAV from "./pages/nav";
import Carousel from "./pages/carousel";
import StockPredict from "./components/Stock_Predict";
import FundaTeaser from "./components/fundamentals/stockFundamentalTeaser";

import Summary from "./components/stocks/summary";
import TechnicalAnalysis from "./components/stocks/stock_technical";
import FundamentalAnalysis from "./components/stocks/stock_fundamentals";
import RiskAnalysis from "./components/stocks/stock_risk";
import OptionsDerivatives from "./components/stocks/stock_options";
import AIML from "./components/stocks/stock_aiml";
// import Financials from "./Financials";
// import Risk from "./Risk";
// import Options from "./Options";
// import SectorComparison from "./SectorComparison";
// import InstitutionalActivity from "./InstitutionalActivity";



function StockPage() {
  const { symbol } = useParams(); // Fetch the stock symbol from the URL params
  const [stkPage, setstkPage] = useState(null);
  const [activeMainTab, setActiveMainTab] = useState("Summary");


const sections = [
  { title: "Summary", component: <Summary data={stkPage}/> },
  { title: "Technicals", component: <TechnicalAnalysis stockSymbol={symbol}/> },
  { title: "Financials", component: <FundamentalAnalysis stockSymbol={symbol}/> },
  { title: "Risk & Volatility", component: <RiskAnalysis stockSymbol={symbol} /> },
  { title: "Options & Derivatives", component: <OptionsDerivatives stockSymbol={symbol} /> },
  { title: "Sector & Peer Comparison", component: <Summary /> },
  { title: "AI & ML Analytics", component: <AIML stockSymbol={symbol} /> },
  { title: "Institutional Activity", component: <Summary /> }
];

  useEffect(() =>
      // Fetch the stock data from an API
      {   console.log('STOCK PAGE 1');
          fetchPage("stockpage", symbol)
      .then(data => {
          const stkPage = JSON.parse(data)
          setstkPage(stkPage);
          console.log('STOCK PAGE 2',stkPage);
      })
      },[symbol])

  return (
      // <StockProvider stockSymbol={symbol}>
      <div>
        {/*<head>*/}

        {/*<!-- Navbar & Hero Start -->*/}
        <div class="container-fluid position-relative p-0">
            <NAV activetag="service"/>
            <Carousel activetag="service"/>

            {/*<!-- Header Start -->*/}
            <div class="container-fluid bg-breadcrumb">
                {/*<div class="container text-center py-5" style={{maxwidth: '500px'}}>*/}
                <div className="container text-center py-2" style={{maxwidth: '500px', maxHeight: '100px'}}>

                    <h4 class="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">{symbol} </h4>
                    <h4 className="text-white display-8 mb-4 wow fadeInDown" data-wow-delay="0.1s">{(stkPage != null) ? stkPage.stock_desc : ""} </h4>
                    {/*<ol class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">*/}
                    {/*    <li class="breadcrumb-item"><a href="index1.html">Home</a></li>*/}
                    {/*    <li class="breadcrumb-item"><a href="#">Pages</a></li>*/}
                    {/*    <li class="breadcrumb-item active text-primary">Service</li>*/}
                    {/*</ol>*/}
                </div>
            </div>
        </div>
            {/*<!-- Header End -->*/}
        {/*<!-- Navbar & Hero End -->*/}

        {/*<!-- Market Snapshot Start -->*/}
        <div class="container-fluid service py-5">
            {/*<div class="container py-5">*/}
                {/*<div class="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxwidth: '800px'}}>*/}
                {/*    /!*<h4 class="text-primary">Our Services</h4>*!/*/}
                {/*    /!*<h1 class="display-5 mb-4">Market Snapshot </h1>*!/*/}
                {/*    /!*<p class="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.*!/*/}
                {/*    /!*</p>*!/*/}
                {/*</div>*/}
                {/*<div class="row g-4">*/}
                    <div className="stock-container">
                      {/* Horizontal Main Tabs */}
                      <div className="main-tabs">
                        {sections.map((section) => (
                          <button
                            key={section.title}
                            className={`main-tab ${activeMainTab === section.title ? "active" : ""}`}
                            onClick={() => setActiveMainTab(section.title)}
                          >
                            {section.title}
                          </button>
                        ))}
                      </div>
                      {/* Vertical Side Navigation & Content */}
                      <div className="content-container">
                        {sections.find((sec) => sec.title === activeMainTab)?.component}
                      </div>
                    </div>
                {/*</div>*/}
            {/*</div>*/}
        </div>

        {/*}<!-- Back to Top -->*/}
        <a href="#" class="btn btn-primary btn-lg-square rounded-circle back-to-top"><i class="fa fa-arrow-up"></i></a>

        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.4/jquery.min.js"></script>
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0/dist/js/bootstrap.bundle.min.js"></script>
        <script src="../public/lib/wow/wow.min.js"></script>
        <script src="../public/lib/easing/easing.min.js"></script>
        <script src="../public/lib/waypoints/waypoints.min.js"></script>
        <script src="../public/lib/counterup/counterup.min.js"></script>
        <script src="../public/lib/lightbox/js/lightbox.min.js"></script>
        <script src="../public/lib/owlcarousel/owl.carousel.min.js"></script>


        <script src="../public/js/main.js"></script>
        <script src="index.js" defer></script>

        {/*</body>*/}

        </div>
      // </StockProvider>
  );
}

export default StockPage;
